// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"_23bcunS9Qq8yRK8U15WWqn","active":"_2zJdO1aspVrGyx-JgFjMYX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 110
// module chunks = 0